module.exports = __webpack_public_path__ + "img/newnotfy.ba81f5d6.svg";